module.exports = __webpack_public_path__ + "static/media/sun-light.a549fd04.svg";